import { FormGroup } from '@angular/forms';
import { ThemeMode } from '@fleet-beat/core';
import { EditorConfig } from '@fleet-beat/editor';

export interface FormDialogOptions {
  currentThemeMode: ThemeMode;
  form: FormGroup;
  config: EditorConfig;
  title?: string;
  accesButtonText: string;
  hasCloseButton?: boolean;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  templateData?: any;
}
